import { gql } from "../../../__generated__/gql";

export const GET_POLLS = gql(`
query polls {
  polls {
    id
    title
    expiryDate
    values
    choices
  }
}
`);